<template>
	<div>
		<div id="dropdown" />

		<div class="md:flex md:flex-col">
			<div class="md:flex md:h-screen md:flex-col">
				<div class="md:flex md:flex-shrink-0">
					<div class="min-w-[320px] bg-[#142b4c] px-6 py-4 md:w-56 md:flex-shrink-0 md:justify-center">
						<div class="flex justify-start">
							<Link class="mt-1" href="/">
								<img class="max-w-[120px]" src="/img/pfzier-logo-white.svg" alt="Pfizer">
							</Link>
						</div>

						<Dropdown class="md:hidden" placement="bottom-end">
							<template #default>
								<svg class="h-6 w-6 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
									<path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
								</svg>
							</template>

							<template #dropdown>
								<div class="mt-2 rounded bg-indigo-800 px-8 py-4 shadow-lg">
									<MainMenu />
								</div>
							</template>
						</Dropdown>
					</div>

					<div class="md:text-md flex w-full items-center justify-between border-b bg-white p-4 text-sm md:px-12 md:py-0">
						<div class="mr-4 mt-1">{{ auth.user.name }}</div>

						<Dropdown class="mt-1" placement="bottom-end">
							<template #default>
								<div class="group flex cursor-pointer select-none items-center">
									<div class="mr-1 whitespace-nowrap text-gray-700 group-hover:text-[#1d3557]">
										<span>{{ auth.user.name }}</span>
									</div>

									<Icon
										class="h-5 w-5 fill-gray-700 group-hover:fill-[#1d3557]"
										name="cheveron-down"
									/>
								</div>
							</template>

							<template #dropdown>
								<div class="mt-2 rounded bg-white py-2 text-sm shadow-xl">
									<Link
										class="block px-6 py-2 hover:bg-[#1d3557] hover:text-white"
										:href="`/users/${auth.user.id}/edit`"
									>
										{{ __('My Profile') }}
									</Link>

									<Link
										class="block px-6 py-2 hover:bg-[#1d3557] hover:text-white"
										href="/users"
									>
										{{ __('Manage Users') }}
									</Link>

									<Link
										class="block w-full px-6 py-2 text-left hover:bg-[#1d3557] hover:text-white"
										href="/logout"
										method="delete"
										as="button"
									>
										{{ __('Logout') }}
									</Link>
								</div>
							</template>
						</Dropdown>
					</div>
				</div>

				<div class="md:flex md:flex-grow md:overflow-hidden js-overflow-hidden">
					<MainMenu class="min-w-[320px] hidden w-56 flex-shrink-0 overflow-y-auto bg-[#1d3557] p-12 md:block" />

					<div class="px-4 py-8 md:flex-1 md:overflow-y-auto md:p-12" scroll-region>
						<FlashMessages />
						<slot />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Link } 	 from '@inertiajs/inertia-vue3'
	import Icon 		 from '@/Shared/Icon'
	import Dropdown      from '@/Shared/Dropdown'
	import MainMenu 	 from '@/Shared/MainMenu'
	import FlashMessages from '@/Shared/FlashMessages'

	export default {
		components: {
			Dropdown,
			FlashMessages,
			Icon,
			Link,
			MainMenu
		},
		props: {
			auth: Object,
		}
	}
</script>
